import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Thai() {
  return (
    <ApiCommunityDirectoryPage
      community="Thai"
      eyebrow="Thai community guide"
      title="Thai favorites, businesses, and local essentials in San Antonio."
      
      tags={["Thai community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the Thai community guide?"
      modalIdPrefix="thai-directory"
    />
  );
}
